import { Button, Form, message } from 'antd';
import React, { useRef, useState } from 'react';
import { Wrapper } from './styled';
import Input, { InputPassword } from 'components/lib/Input';
import { Link, useNavigate } from 'react-router-dom';
import useLogged from 'hooks/useLogged';
import queryString from 'query-string';
import { useEffect } from 'react';
import CryptoJS from 'crypto-js';
import { encryptUtils } from 'utils';
import { ENCRYPT_KEY } from 'enviroments';
import userProvider from 'data-access/user-provider';
import { v4 as uuidv4 } from 'uuid';
import { _setToken } from 'utils/cookie-token';
// import ModalVerify, { RefOption } from './ModalVerify';

function Login() {
  const navigate = useNavigate();
  // const modalRef = useRef<RefOption>({
  //   open: () => {
  //     //
  //   }
  // });
  const { redirectUrl } = queryString.parse(location.search);
  const isLogged = useLogged();
  const [form] = Form.useForm();
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);

  useEffect(() => {
    if (isLogged) {
      redirectUrl
        ? (window.location.href = redirectUrl as string)
        : navigate('/', { replace: true });
    }
  }, [isLogged]);

  const handleClickedBtnSubmit = (values) => {
    setIsLoadingBtn(true);
    const sessionId = uuidv4();
    const password = CryptoJS.MD5(encryptUtils(values.password, ENCRYPT_KEY)).toString();

    values = { ...values, password, session_id: sessionId };

    userProvider
      .login(values)
      .then((res: any) => {
        const { token: access_token, role } = res;

        if (['FREE_USER', 'VIP_USER'].includes(role)) {
          message.warning(
            'Bạn không có quyền truy cập. Vui lòng liên hệ với admin để biết thêm chi tiết!'
          );
          return;
        }

        _setToken(access_token);

        window.location.href = (redirectUrl as string) || '/';
      })
      .catch((err) => {
        const code = err?.response?.data?.code;
        if (code === 'UNPROCESSABLE_ENTITY') {
          message.error('Thông tin đăng nhập không đúng!');
        } else {
          message.error('Lỗi không xác định vui lòng thử lại!');
        }
      })
      .finally(() => setIsLoadingBtn(false));
    // .then(() => {
    //   userProvider
    //     .login({ ...values, session_id: sessionId })
    //     .then(() => {
    //       window.sessionStorage.setItem('session_id', sessionId);
    //       modalRef.current?.open();
    //       window.sessionStorage.setItem(
    //         'infor_login',
    //         JSON.stringify({
    //           phone_or_email: values.phone_or_email,
    //           password: values.password
    //         })
    //       );

    //       window.sessionStorage.setItem('verify_method', 'email');

    //       router.push({
    //         pathname: '/login/verify',
    //         query: {
    //           redirect
    //         }
    //       });
    //     })
    //     .catch((err) => {
    //       message.error(
    //         err?.response?.status
    //           ? 'Thông tin đăng nhập không đúng!'
    //           : err.message || 'Lỗi không xác định. Vui lòng thử lại sau!'
    //       );
    //     })
    //     .finally(() => {
    //       setIsLoadingBtn(false);
    //     });
    // })
    // .catch((err) => {
    //   setIsLoadingBtn(false);
    //   message.error(
    //     err?.response?.status
    //       ? 'Thông tin đăng nhập không đúng!'
    //       : err.message || 'Lỗi không xác định. Vui lòng thử lại sau!'
    //   );
    // });
  };

  return (
    <Wrapper className="flex flex-col justify-center w-full h-screen items-center">
      <img src="https://takeprofit.vn/images/home/logo_login.svg" alt="logo" />
      <div className="login-box w-3/6 rounded-md mt-8 p-10 ">
        <div className="mb-10">
          <h1 className="title-login text-dark text-2xl text-center font-semibold mb-3">
            Sign In to TakeProfit
          </h1>
          <div className="sub-title-login text-center text-gray-500 font-medium text-lg">
            New Here?{' '}
            <Link to="/signup" className="font-semibold link-primary">
              Create an Account
            </Link>
          </div>
        </div>
        <Form
          layout="vertical"
          form={form}
          initialValues={{ remember: true }}
          onFinish={handleClickedBtnSubmit}
          onFinishFailed={() => {
            // Todo
          }}>
          <Form.Item
            label="Nhập số điện thoại hoặc email"
            className="mb-10"
            name="phone_or_email"
            rules={[
              {
                required: true,
                message: 'Email hoặc số điện thoại không được để trống!'
              },
              {
                // eslint-disable-next-line no-useless-escape
                pattern: /^[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\w\d]+$/,
                message: 'Email hoặc số điện thoại không hợp lệ!'
              }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            className="mb-10"
            name="password"
            rules={[
              {
                required: true,
                message: 'Mật khẩu không được để trống!'
              },
              {
                // eslint-disable-next-line no-useless-escape
                pattern: /^[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\w\d]+$/,
                message: 'Mật khẩu chỉ bao gồm chữ, số  hoặc ký tự đặc biệt!'
              },
              { min: 8, message: 'Mật khẩu phải trên 8 ký tự!' },
              {
                max: 32,
                message: 'Mật khẩu phải dưới 32 ký tự!'
              }
            ]}
            label={
              <div className="flex justify-between w-full">
                <span>Mật khẩu</span>
                <span className="link-primary">Forgot Password ?</span>
              </div>
            }>
            <InputPassword />
          </Form.Item>
          <Form.Item className="mb-10">
            <Button
              htmlType="submit"
              type="primary"
              loading={isLoadingBtn}
              className="w-full rounded-md pt-3 pb-3 pr-5 pl-5 h-14 bg-sky-500">
              Continue
            </Button>
          </Form.Item>
        </Form>
      </div>
      {/* <ModalVerify redirectUrl={redirectUrl as string} ref={modalRef} /> */}
    </Wrapper>
  );
}

export default Login;
